module.exports = __webpack_public_path__ + "static/img/govcard_04.84efff2e.svg";